import { InfoCircleOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Col,
    Empty,
    Form,
    Image,
    Input,
    Modal,
    notification,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Tooltip
} from "antd";
import { useEffect, useState } from "react";
import { getMacTemplateAppRestriction, addMacTemplateAppRestriction,deleteMacTemplateAppRestriction } from "../../../axios/api.device";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

const { Column } = Table
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    updateTemplate: () => void,
}

export const MacContentAppRestriction = (props: propsModel) => {
    const { templateId, platform, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [selType, setSelType] = useState<boolean>(true);

    const [appNames, setAppNames] = useState<any[]>([{ id: uuidv4(), value: "" }]);

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }

    useEffect(() => {
        getDataInfo();
    }, [])

    const getDataInfo = () => {
        getMacTemplateAppRestriction(templateId).then((res) => {
            if (res && res != null) {
                if (res.appNames && res.appNames.length > 0) {
                    setShowTable(2);
                    setSelType(res.isKillProcess);
                    setAppNames(res.appNames);
                } else {
                    setShowTable(1)
                }
            } else {
                setShowTable(1)
            }
        })
    }

    const updateObjectInArray = (arr:any, indexToUpdate:any, newValues:any) => {
        return arr.map((item:any) => 
          item.id === indexToUpdate ? {...item, ...newValues} : item
        );
    };

    const addTemplateClick = () => {
        const values = appNames
            .filter(({ id, value }) => !value)
            .map(({ value }) => value);
        
        if (values.length >= 1) {
            notification.warning({ message: t("请输入应用进程名称") });
            return;
        }
        console.log(values);
        // if(values.includes(""))
        // {
        //     notification.warning({ message: t("请输入应用进程名称") });
        //     return;
        // }
        console.log(appNames,selType);
        addMacTemplateAppRestriction(templateId, {appNames: appNames, isKillProcess: selType}).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            getDataInfo();
        },()=>{
        });
        //setAppNames([{ id: uuidv4(), value: "" }]);
    }

    const deleteTemplateClick = () => {
        deleteMacTemplateAppRestriction(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            getDataInfo();
        })
    }

    function showTypeChange(e: any) {
        setSelType(e);
    }

    const onAddInput = () => {
        var aNames = [
            ...appNames,
            {
              id: uuidv4(),
              value: "",
            },
          ];
        setAppNames(aNames);
    };

    const onRemoveInput = (id: string) => {
        var aNames = appNames.filter((item) => item.id !== id);
        setAppNames(aNames);
    };

    const onInputChange = (id: string, value: string) => {
        var newVals = updateObjectInArray(appNames,id,{value:value})
        setAppNames(newVals);
    };

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("应用限制")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置禁止用户使用的应用")} </p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ width: "80%",paddingLeft:"80px" }}>
                        <Row className="mb-1">
                            <Col span={18}>
                                <span style={{ color: 'red',paddingRight:'2px' }}>*</span>
                                <label style={{lineHeight:"30px"}} htmlFor="">{t("应用进程名称")}</label>
                            </Col>
                        </Row>
                        {appNames.map(({ id, value }, index) => {
                            return (
                                <Row className="mb-1" key={id} justify="space-between">
                                    <Col span={20}>
                                        <div>
                                        <Input
                                            placeholder={t("进程名称")}
                                            value={value}
                                            onChange={(e) =>
                                                onInputChange(id, e.target.value)
                                            }
                                        ></Input>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div>
                                            <Button
                                                type="dashed"
                                                disabled={index === 0 ? true : false}
                                                onClick={() => { onRemoveInput(id); }}
                                            >
                                                -
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            );
                        })}
                        <Row className="mt-3">
                            <Col span={24}>
                                <Button type="dashed" onClick={() => { onAddInput(); }} block>
                                +{t("添加应用")}
                                </Button>
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col span={18}>
                                <span style={{ color: 'red',paddingRight:'2px' }}>*</span>
                                <label style={{lineHeight:"30px", paddingRight:"30px",paddingTop:"20px"}} htmlFor="">{t("终止进程")}</label>
                                <Select value={selType} onChange={showTypeChange} >
                                    <Select.Option value={true}>{t("是")}</Select.Option>
                                    <Select.Option value={false}>{t("否")}</Select.Option>
                                </Select>
                            </Col>
                        </Row>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </Row>
        </div>

    </>)
};